import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabatSharedMessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import ConversationType from "./ConversationType";
import ConverstionStates from "./conversation-states";

const Header = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { theme, conversationID } = props;
  const { colors } = theme;

  const conversationType =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get();

  return (
    <ET3Div
      width={1450}
      height={50}
      alignItems={"center"}
      fDirection={"row"}
      style={{
        borderTop:
          conversationType === "101C"
            ? 0
            : `1px solid ${colors.all.shadeOfGray}`
      }}
      color={""}
      justifyContent={"space-between"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <ConversationType conversationID={conversationID} />
      <ConverstionStates conversationID={conversationID} />
    </ET3Div>
  );
});

export default Header;
